const _import = require('@/utils/import/_import_' + process.env.NODE_ENV)

export default [
  {
    path: 'hookah-makers',
    name: 'Hookahmakers',
    component: {
      template: '<div class="content-wrapper"><router-view></router-view></div>',
    },
    meta: {
      title: 'Кальянщики',
      menuKey: 'Settings',
      roles: ['ROLE_ADMIN', 'ROLE_WAITER']
    },
    children: [
      {
        path: '',
        name: 'Hookahmakers.list',
        component: _import('settings/components/Hookah/list'),
        meta: {
          title: 'Кальянщики',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'create',
        name: 'Hookahmakers.create',
        component: _import('settings/components/Hookah/create'),
        meta: {
          title: 'Новый кальянщик',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: ':id/edit',
        name: 'Hookahmakers.edit',
        component: _import('settings/components/Hookah/edit'),
        meta: {
          title: 'Изменение кальянщика'
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/settings/components/Hookah/routes.js